import AOS from 'aos';
/*import {
	Fancybox,
	Carousel,
	Panzoom
} from "@fancyapps/ui"; */
import {
	Fancybox,
	Panzoom
} from "@fancyapps/ui";
import { Toolbar } from "@fancyapps/ui/dist/panzoom/panzoom.toolbar.esm.js";
import mixitup from 'mixitup';

import Sticky from 'sticky-js';
var sticky = new Sticky('[data-sticky]', {});

//import Panzoom from '@panzoom/panzoom';

import Swiper from 'swiper/bundle';
exports.swiper = Swiper;

import mapboxgl from 'mapbox-gl';
exports.mapboxgl = mapboxgl;

import DataTable from 'datatables.net-bs5';
import 'datatables.net-rowgroup-bs5';
import 'datatables.net-scroller-bs5';
import 'datatables.net-select-bs5';
import 'datatables.net-fixedheader-bs5';


AOS.init({
	once: true,
	duration: 800, // values from 0 to 3000, with step 50ms
	easing: 'ease-in-out',
	initClassName: false,
	anchorPlacement: 'center-bottom'
});

Fancybox.bind("[data-fancybox]", {
	hideScrollbar: true,
});

jQuery(function ($) {
	$(document).on('change', 'input[name="category"]', function () {
		$(this).closest('form').trigger('submit');
	})

	$('#filter-form').on('submit', function (event) {
		event.preventDefault();
		var formData = $(this).serialize();

		$.ajax({
			url: elixir_gnAjax.ajaxurl, // The WordPress AJAX handler
			data: formData,
			dataType: 'json',
			type: 'POST',
			beforeSend: function () {
				$('#elixir_gn_posts_wrap').addClass('loading');
			},
			success: function (data) {
				// when filter applied:
				// set the current page to 1
				elixir_gnAjax.current_page = 1;

				// set the new query parameters
				elixir_gnAjax.posts = data.posts;

				// set the new max page parameter
				elixir_gnAjax.max_page = data.max_page;



				$('#elixir_gn_posts_wrap').removeClass('loading').html(data.content);
				// hide load more button, if there are not enough posts for the second page
				if (data.max_page < 2) {
					$('#elixir_gn_loadmore').hide();
				} else {
					$('#elixir_gn_loadmore').show();
				}
			},
			error: function (xhr, status, error) {
				$('#elixir_gn_posts_wrap').html('<p>Error occurred. Please try again later.</p>');
				console.log(xhr.responseText);
			}
		});
	});

	/*
	 * Load More
	 */
	$('#elixir_gn_loadmore').click(function () {

		$.ajax({
			url: elixir_gnAjax.ajaxurl, // AJAX handler
			data: {
				'action': 'loadmorebutton', // the parameter for admin-ajax.php
				'query': elixir_gnAjax.posts, // loop parameters passed by wp_localize_script()
				'page': elixir_gnAjax.current_page // current page
			},
			type: 'POST',
			beforeSend: function (xhr) {
				$('#elixir_gn_loadmore').text('Loading...'); // some type of preloader
			},
			success: function (posts) {
				if (posts) {
					//console.log(posts);
					$('#elixir_gn_loadmore').text('More posts');
					$('#elixir_gn_posts_wrap').append(posts); // insert new posts
					elixir_gnAjax.current_page++;

					if (elixir_gnAjax.current_page == elixir_gnAjax.max_page)
						$('#elixir_gn_loadmore').hide(); // if last page, HIDE the button

				} else {
					$('#elixir_gn_loadmore').hide(); // if no data, HIDE the button as well
				}
			}
		});
		return false;
	});

	$('#prikaz-toggle').on('change', function () {
		// Check if the checkbox is checked
		if (this.checked) {
			// Add the 'show-all' class to all elements with class 'prikaz-lamela'
			$('.prikaz-lamela').addClass('show-all');
			document.cookie = "showAll=true; path=/";
		} else {
			// Remove the 'show-all' class from all elements with class 'prikaz-lamela'
			$('.prikaz-lamela').removeClass('show-all');
			//document.cookie = "showAll=false; path=/";
			document.cookie = "showAll=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/";
		}
	});

	//datatables
	var dataTables = [];
	document.querySelectorAll('.ponude-table').forEach(function (element) {
		var table = $(element).DataTable({
			fixedHeader: {
				headerOffset: $('#wrapper-navbar').outerHeight()
			},
			columnDefs: [
				{ targets: [5,6], visible: false },
				{ targets: '_all', orderable: false }
			],
			order: [[1, 'asc']],
			/*rowGroup: {
				dataSrc: 2
			},*/
			paging: false,
			info: false,
			pageLength: -1,
			dom: 'rtip',
			language : {
				"zeroRecords": "Nema rezultata.",
			}
		});
		
		dataTables.push(table);
		
	});

	$(document).on('change', '.table-filter', function () {
		dataTables.forEach(function (table) {
			multiColumnSearch(table);
		});
	});

	$(document).on('change', '.struktura-filter', function () {
		var selectedValue = $(this).val();

        // Iterate through each MixItUp instance and apply the filter
        mixers.forEach(function (mixer) {
            mixer.filter(selectedValue);
        });
	});

	function multiColumnSearch(table) {
		// Initialize an array to store conditions for each column
		var columnConditions = [];

		// Iterate through the checked checkboxes and construct conditions
		$('.table-filter').each(function () {
			var column = $(this).data('column');
			var value = $(this).val();
			// Construct a condition for the current checkbox
			var condition = `(?=.*${value})`;

			// Add the condition to the array for the corresponding column
			columnConditions[column] = columnConditions[column] || [];
			columnConditions[column].push(condition);
		});

		// Construct the final regular expression for each column
		var regexArray = columnConditions.map(function (conditions) {
			return conditions.join('');
		});

		// Construct the final regular expression with AND logic for all columns
		var searchRegex = regexArray.join('');

		// Perform the search
		table.search(searchRegex, true, false).draw();
	}

	//view selector
	$(".view-select").click(function () {
		const target = $(this).data('target');
		var sel = document.querySelector(target);
		elixir_gn.Tab.getOrCreateInstance(sel).show()
	})

	//filters
	var letters = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i'];
	var mixers = [];
	for (var i = 0; i < letters.length; i++) {
		var containerId = 'lamela-' + letters[i] + '-mix';
		var config = {
			controls: {
				scope: 'local'
			}
		};
		if ($('#' + containerId).length) {
			var mixer = mixitup('#' + containerId);
			mixers.push(mixer);
		}
	}
});

document.addEventListener("DOMContentLoaded", function () {

	// Get the header element
	const header = document.querySelector("#wrapper-navbar");
	const toggleClass = "sticky";

	window.addEventListener("scroll", () => {
		const currentScroll = window.pageYOffset;
		if (currentScroll > 0) {
			header.classList.add(toggleClass);
		} else {
			header.classList.remove(toggleClass);
		}
	});
	var popoverOptions = {
		html: true,
		container: 'body',
		placement: 'auto',
		trigger: 'hover focus',
		content: function (el) {
			var popoverID = el.getAttribute('id');
			var contentID = popoverID + '_opis';
			var content = document.getElementById(contentID);
			return content.innerHTML;
		}

	}
	var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'))
	var popoverList = popoverTriggerList.map(function (popoverTriggerEl) {
		return new elixir_gn.Popover(popoverTriggerEl, popoverOptions)
	});

	const elems = document.querySelectorAll('.f-panzoom');
	const options = {
		transformParent: true,
		click: false,
		panOnlyZoomed: false
	};
	var containerRect, pan = false;
	elems.forEach((elem) => {
		if (pan == false) {
			containerRect = elem.getBoundingClientRect();
			pan = -1 * (((containerRect.height / 9 * 16) / 2) - (containerRect.width / 2));
		}
		//console.log(pan);
		const pzoom = new Panzoom(elem, options);
		pzoom.zoomToCover();
		window.addEventListener("resize", (event) => {
			containerRect = elem.getBoundingClientRect();
			pan = -1 * (((containerRect.height / 9 * 16) / 2) - (containerRect.width / 2));
			pzoom.zoomToCover();
		});
		pzoom.on('ready', function () {
			pzoom.panTo({ x: pan });
		});
		pzoom.on('refresh', function () {
			//console.log('refresh');
			pzoom.panTo({ x: pan });
		});

	});
	// Check if the device supports touch events
	if ('ontouchstart' in document.documentElement) {
		// Find all 'a' elements within the SVG
		const linkElements = document.querySelectorAll('svg a');

		// Iterate through the 'a' elements and attach the event handler
		linkElements.forEach(link => {
			link.addEventListener('click', function (event) {
				if (link.classList.contains('touched')) {
					// If the link has been touched before, allow the default click behavior
					link.classList.remove('touched'); // Reset the touched state
				} else {
					// If this is the first touch, prevent the default click behavior
					event.preventDefault();

					link.classList.add('touched'); // Set the touched state
					// Show your popover here using your preferred method
					// For example, if you're using Bootstrap:
					// $('#ponuda_1-62').popover('show');
					linkElements.forEach(otherLink => {
						if (otherLink !== link) {
							otherLink.classList.remove('touched');
						}
					});
				}
			});
		});
	}
});

window.geojsonData = window.geojsonData || {
	type: "FeatureCollection",
	features: []
};